import { useState } from 'react';
import liff from '@line/liff';

const useLineLiff = (liffId) => {
  const [liffInit, setLiffInit] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [status, setStatus] = useState('Pending...');
  const [errorMsg, setErrorMsg] = useState();

  if (!liffInit) {
    const fetchUserInfo = async () => {
      try {
        const liffData = await liff.getProfile();
        setUserInfo(liffData);
        setStatus('LIFF initialized');
      } catch (err) {
        setErrorMsg(`error occurred while getting user info: ${err.message}`);
      }
    };

    liff
      .init({ liffId: liffId })
      .then(() => {
        setLiffInit(true);
      })
      .then(() => {
        if (!liff.isLoggedIn())
          return liff.login({
            redirectUri: window.location.href,
          });
        fetchUserInfo();
      })
      .catch((err) => {
        setErrorMsg(`error occurred while initializing LIFF: ${err.message}`);
      });
  }

  return { liff, userInfo, status, setStatus, errorMsg, setErrorMsg };
};

export default useLineLiff;
